import React from "react";
import TagManager from "./TagManager";

export default function TagFamiliesEditor() {
  return (
    <div className="card-flat p-5 lg:col-span-2" data-testid="tag-families-editor">
      <div className="mb-3">
        <h3 className="font-heading text-lg font-medium text-norea-text">Tags des dossiers</h3>
        <p className="text-xs text-norea-textMuted mt-0.5">Chaque famille a sa couleur, partagée par ses tags. Les modifications sont enregistrées immédiatement. Les familles « Auto » sont protégées.</p>
      </div>
      <TagManager grid />
    </div>
  );
}
